module.exports = __webpack_public_path__ + "img/news-container-bg.0f327360.png";